<template>
    <div id="index">
        <div style="width:100%;display:flex;">
            <div style="width:100%;box-sizing:border-box;">
                <el-card class="box-card" v-for="item in companyList.slice(0, 1)" :key="item.companyId"
                    style="width:33%;margin: .25rem auto;margin-top: .375rem;font-weight:bold;line-height: .375rem;color:#555555;font-size: .1875rem;">
                    <div class="text item" style="font-size: .2375rem;color: #dd3531;font-weight: bold;">{{ item.companyName
                        }}</div>
                    <div class="text item">电话 {{ item.companyPhone }}</div>
                    <div class="text item" style="height: .3125rem;line-height: .25rem;">地址 {{ item.companyAdd }}</div>
                </el-card>
                <div class="compBox">
                    <el-card class="box-card" v-for="item in companyList.slice(1)" :key="item.companyId">
                        <div class="text item" style="font-size: .225rem;color: #dd3531;font-weight: bold;">{{ item.companyName }}</div>
                        <div class="text item">电话 {{ item.companyPhone }}</div>
                        <div class="text item" style="height: .3125rem;line-height: .25rem;">地址 {{ item.companyAdd }}</div>
                    </el-card>
                </div>
            </div>
        </div>
        <!-- 地图 -->
        <div style="width:100%;height:calc(100vh - 6.75rem);border: .0125rem solid rgb(204, 204, 204);box-sizing: border-box;">
            <el-amap class="amap-demo" :zoom="zoom" :center="center">
                <el-amap-marker vid="amapDemo" v-for="marker in markers" :position="marker.position" :key="marker.id"
                    :events="marker.events">
                </el-amap-marker>
                <el-amap-text v-for="(text, index) in markers" :text="text.text" :offset="text.offset"
                    :position="text.position" :key="index" :events="text.event"></el-amap-text>
            </el-amap>
        </div>
        <!-- <v-footer></v-footer> -->
    </div>
</template>
<script>
// import vFooter from '../common/footer.vue';
import { gwGetCompanyList } from '@/api/index';
export default {
    // components: {
    //     vFooter
    // },
    data() {
        return {
            languageType: '1',
            companyList: [],
            zoom: 4.5,
            lng: 0,
            lat: 0,
            markers: [],
            pointMarker: [
                // {
                //     pointX: 116.36,
                //     pointY: 39.67,
                //     text: '北京普发动力控股股份有限公司'
                // },
                // {
                //     pointX: 126.48,
                //     pointY: 45.81,
                //     text:
                //         "<div class='text' style='text-align:center;'>" +
                //         '哈尔滨普发新能源有限公司' +
                //         '</div>' +
                //         "<div class='text' style='text-align:center;'>" +
                //         '哈尔滨通源供电有限责任公司' +
                //         '</div>'
                // },
                // {
                //     pointX: 126.67,
                //     pointY: 45.73,
                //     text: '哈尔滨普发香滨新能源有限公司'
                // },
                // {
                //     pointX: 126.61,
                //     pointY: 45.74,
                //     text: '哈尔滨市庆能源有限公司'
                // },
                // {
                //     pointX: 128.01,
                //     pointY: 45.21,
                //     text: '黑龙江普发动力能源有限公司'
                // },
                // {
                //     pointX: 126.49,
                //     pointY: 45.84,
                //     text: '哈尔滨普发新能源装备科技有限公司'
                // }
            ],
            center: [122.25, 43.66]
        };
    },
    //必须写在mounted方法中
    mounted() {
        // this.point();
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetCompanyList();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.gwGetCompanyList();
        });
    },
    methods: {
        point() {
            let markers = [];
            let that = this;
            that.pointMarker.forEach((item, index) => {
                markers.push({
                    position: [item.pointX, item.pointY],
                    icon: item.url, //不设置默认蓝色水滴
                    text: item.text,
                    event: item.event,
                    offset: [5, -50]
                });
            });
            //  加点
            that.markers = markers;
        },
        gwGetCompanyList() {
            let params = {
                language: this.languageType
            };
            gwGetCompanyList(params).then(res => {
                console.log('查询公司名片集合', res.obj);
                this.companyList = res.obj;
                const pointMarker = res.obj.map(item => {
                    return { pointX: item.companyX, pointY: item.companyY, text: item.companyName };
                });
                this.pointMarker = pointMarker;
                this.point();
            });
        }
    }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

// @{deep}.el-vue-amap-container {
//     position: relative;
// }
@{deep}.amap-marker-label {
    font-size: .175rem;
    border: .0125rem solid #ff8100;
}

//padding:140px 100px 100px 400px;
.compTitle {
    text-align: center;
    margin-top: .35rem;
}

.compBox {
    width: 80%;
    margin: auto;
    display: flex;
    // justify-content: center;
    justify-content: space-between;
    line-height: .35rem;
    flex-wrap: wrap;
    align-items: center;

    .box-card {
        width: 32%;
        font-weight: bold;
        color: #555555;
        font-size: .175rem;
        margin-bottom: .25rem;
        padding: .25rem;
        box-sizing: border-box;

        @{deep}.el-card__body {
            padding: 0 !important;
        }
    }
}
</style>
